var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "navSvgItem" },
    [
      _vm.currentIndex == 1
        ? [
            _vm.active != 1
              ? _c("img", {
                  staticClass: "nav-icon",
                  attrs: {
                    src: require("@/assets/images/home_new/menu_icon/home.svg"),
                    alt: "",
                  },
                })
              : _c("img", {
                  staticClass: "nav-icon",
                  attrs: {
                    src: require("@/assets/images/home_new/menu_icon/home_h.svg"),
                    alt: "",
                  },
                }),
          ]
        : _vm._e(),
      _vm.currentIndex == 2
        ? [
            _vm.active != 2
              ? _c("img", {
                  staticClass: "nav-icon",
                  attrs: {
                    src: require("@/assets/images/home_new/menu_icon/hld.svg"),
                    alt: "",
                  },
                })
              : _c("img", {
                  staticClass: "nav-icon",
                  attrs: {
                    src: require("@/assets/images/home_new/menu_icon/hld_h.svg"),
                    alt: "",
                  },
                }),
          ]
        : _vm._e(),
      _vm.currentIndex == 3
        ? [
            _vm.active != 3
              ? _c("img", {
                  staticClass: "nav-icon",
                  attrs: {
                    src: require("@/assets/images/home_new/menu_icon/csgo.svg"),
                    alt: "",
                  },
                })
              : _c("img", {
                  staticClass: "nav-icon",
                  attrs: {
                    src: require("@/assets/images/home_new/menu_icon/csgo_h.svg"),
                    alt: "",
                  },
                }),
          ]
        : _vm._e(),
      _vm.currentIndex == 4
        ? [
            _vm.active != 4
              ? _c("img", {
                  staticClass: "nav-icon",
                  attrs: {
                    src: require("@/assets/images/home_new/menu_icon/wareflare.svg"),
                    alt: "",
                  },
                })
              : _c("img", {
                  staticClass: "nav-icon",
                  attrs: {
                    src: require("@/assets/images/home_new/menu_icon/wareflare_h.svg"),
                    alt: "",
                  },
                }),
          ]
        : _vm._e(),
      _vm.currentIndex == 5
        ? [
            _vm.active != 5
              ? _c("img", {
                  staticClass: "nav-icon",
                  attrs: {
                    src: require("@/assets/images/home_new/menu_icon/stock.svg"),
                    alt: "",
                  },
                })
              : _c("img", {
                  staticClass: "nav-icon",
                  attrs: {
                    src: require("@/assets/images/home_new/menu_icon/stock_h.svg"),
                    alt: "",
                  },
                }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }